module.exports = __webpack_public_path__ + "static/media/S2N9-4.866402fb.svg";